<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Booster {{ CollectionCardRankType[boosterRankType] }}</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Cards Drop Count</label>
          <input class="form-control" [(ngModel)]="cardsDropCount" type="number" min="0">
        </div>

        <hr/>
        <h6>Drops (rarity weight)</h6>
        <table class="table table-sm mb-0">
          <thead class="thead-light">
            <tr>
              <th>Card Rank</th>
              <th>Rarity Weight</th>
              <th>Chance</th>
            </tr>
          </thead>
          <tbody>
            @for (drop of drops; track drop.cardRankType) {
              <tr>
                <td class="align-middle">{{ CollectionCardRankType[drop.cardRankType] }}</td>
                <td><input class="form-control form-control-sm" [(ngModel)]="drop.rarityWeight" type="number" min="0"></td>
                <td class="align-middle">{{ getDropPercent(drop) | number:'1.0-2' }} %</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
